import classes from "../ServicesTable.module.scss"
import { Fragment, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm, Controller  } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from "../../UI/Button";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CertificateField from "../CertificateField";
import { OrgIdContext } from "../../../store/orgId_context";
import { DDD, E2Data } from "../../../lib/ddd/ddd";
import { GenericTooltip } from "../../integrationWizard/form/GenericTooltip";
import {stringExpressionReplacement} from "../../../lib/ddd/helpers"
import { NotificationManager} from 'react-notifications';
import { Button as MButton, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import CertificateInput from "../servicesTable/CertificateInput";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import PaymentsIcon from '@mui/icons-material/Payments';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import HelpIcon from '@mui/icons-material/Help';
import FiscalizationForm from "./FiscalizationForm";
import { useQuery } from "@tanstack/react-query";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new E2Data("VP_DevicesOrgUnits");
const _ddd = new DDD(apiRequestAddress);



const DeviceForm = ({data:importedData, info, onSubmit:submitCallback, editable=true, payments, orgData, onDataChanged}) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [fields, setFields] = useState({});
    const [defaults, setDefaults] = useState({});
    const [showPasswords, setShowPasswords] = useState(false);
    const [confirmDialog,setConfirmDialog] = useState(false);
    const [deactivateBtn, setDeactivateBtn] = useState(false);
    const [unlistedFields, setUnlistedFields] = useState([]);
    const [connectedFields, setConnectedFields] = useState([]);
    const { isMaintainer, sessionInfo } = useContext(OrgIdContext);
    const fiscForm = useRef();
    const {t} = useTranslation();

    

    const blankCodeForTranslator = (fieldName) => {
        t("Wholesale");
        t("Retail");
    }

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm();
//#region field helpers
    useEffect(() => {
        if(importedData)
            setData(importedData);
        if(info && info?.result?.tables?.[0]?._fields)
            setFields(info && info?.result?.tables?.[0]?._fields);
    }, [importedData, info]);

    useEffect(() => {
        if(data)
            reset(data);
        console.log(fields);
    }, [fields, data]);

    const getFieldInfo = (fieldName) => {
        if(fields.hasOwnProperty(fieldName)) return fields[fieldName];
        
        return null;
    }

    const getFieldValue = (fieldName) => {
        return data[fieldName]||null;
    }

    const getValidValues = (fieldName) => {
        const _info = getFieldInfo(fieldName);
        if(_info && _info._validValues){
            let ret = [null];
            _info._validValues.forEach(vv => {
                ret.push(vv.Title);
            });
            return ret;
        }
        return [];
    }
    const getIconForAll = (value) => {
        switch(value){
            case "Wholesale":
                return <WarehouseIcon className="main-blue"/>
            case "Retailsale":
                return <ShoppingCartIcon className="main-blue"/>
            case "CASH":
                return <PaymentsIcon className="main-blue"/>
            case "NONCASH":
                return <CreditCardIcon className="main-blue"/>
            case "COMBINE":
                return <LocalAtmIcon className="main-blue"/>
            default:
                return null;
        }
    }

    const getFieldElement = (fieldName, type, props) => {
        const _info = getFieldInfo(fieldName);
        const val = getFieldValue(fieldName);

        if(fieldName === "PaymentTypeDefaultSC")
            return paymentTypeSelect(fieldName);
        switch(type){
            case "textarea":
            case "TextArea":
                return(
                    <textarea
                    key={fieldName+"field"}
                    placeholder={"Enter email"}
                    rows="3"
                    disabled={!editable}
                    {...props}
                    {...register(fieldName)}
                />
                )
            case "mail":
                return(
                    <input
                    key={fieldName+"field"}
                    placeholder={"Enter email"}
                    type="email"
                    disabled={!editable}
                    {...register(fieldName)}
                />
                )
            case "datetime":
            case "DateTime":
                return(
                    <input
                    key={fieldName+"field"}
                    type="datetime-local"
                    disabled={!editable}
                    step="1"
                    {...register(fieldName)}
                />
                )
            case "file":
                return (
                    <>
                    <CertificateInput
                    name={fieldName}
                    register={register}
                    setValue={setValue}
                    disabled={!editable}
                    control={control}
                    />
                </>)
            case "date":
                return (<input
                    key={fieldName+"field"}
                    type="date"
                    disabled={!editable}
                    {...register(fieldName)}
                />)
            case "password":
                return (
                <>
                <div className="input-group" style={{flexWrap:"nowrap"}}>    
                <input
                    key={fieldName+"field"}
                    placeholder={"Enter password"}
                    autocomplete="new-password"
                    disabled={!editable}
                    type={showPasswords ? "text" : "password"}
                    {...register(fieldName)}
                />
                    <span onClick={() => setShowPasswords(val => !val)} className="input-group-text" style={{border:"none", outline:"1.5px solid #005683", backgroundColor:"white", cursor:"pointer"}}>
                        <VisibilityIcon style={{fontSize:"1rem"}}/>
                    </span>
                </div>
                </>)
            case "bool":
                let menuItems = [{value : true, title : "True", icon:(<CheckCircleIcon/>)}, {value:false, title:"False", icon:(<UnpublishedIcon/>)}];
                return (
                    <Controller
                     control={control}
                     name={fieldName}
                     disabled={!editable}
                     key={fieldName+"field"}
                     defaultValue={val}
                     render= {(({field})=>{
                    return(<Select
                        className={classes["inputselect"]}
                        style={{borderRadius:"10px"}}
                        disabled={!editable}
                        key={fieldName+"field"}
                        {...field}
                        >
                            {menuItems.map((value, index) => (
                                <MenuItem value={value.value} key={index}>
                                    {value.icon} {value.title}
                                </MenuItem>
                            ))}
                            
                    </Select>)
                    })}/>)
            case "select":
                let validValues = getValidValues(fieldName);
                return (
                    <Controller
                     control={control}
                     name={fieldName}
                     disabled={!editable}
                     defaultValue={val}
                     key={fieldName+"field"}
                     render= {(({field})=>{
                    return(<Select
                        className={classes["inputselect"]}
                        style={{borderRadius:"10px"}}
                        key={fieldName+"field"}
                        disabled={!editable}
                        {...field}
                        >
                            {validValues.map((value, index) => (
                                <MenuItem value={value} key={fieldName+"field"+index}>
                                    {getIconForAll(value)} {value ? t(value) : <span style={{visibility:"hidden"}}>None</span>}
                                </MenuItem>
                            ))}
                            
                    </Select>)
                    })}/>)
            default:
                return (<input
                            key={fieldName+"field"}
                            disabled={!editable}
                            placeholder={""}
                            {...register(fieldName)}
                        />)
        }
    }

    const paymentTypeSelect = (fieldName) => {
        const val = getFieldValue(fieldName);
        const found = payments?.find(p => p.CountryCodeSC__CountryCode !== null || p.CountryCodeSC__CountryCode !== undefined);
        return (
            <Controller
                control={control}
                name={fieldName}
                disabled={!editable}
                defaultValue={val}
                key={fieldName+"field"}
                render= {(({field})=>{
            return(<Select
                className={classes["inputselect"]}
                style={{borderRadius:"10px"}}
                key={fieldName+"field"}
                disabled={!editable}
                {...field}
                >
                    <MenuItem value={null} key={fieldName+"fieldnull"}>
                        <span style={{visibility:"hidden"}}>None</span>
                    </MenuItem>
                    {payments?.map((value, index) => {
                        if(!value.CountryCodeSC__CountryCode && found) return null;
                        return <MenuItem value={value.Id} key={fieldName+"field"+index}>
                            {getIconForAll(value.Code)} {value.CodeName}
                        </MenuItem>
                    })}
                    
            </Select>)
            })}/>)
    }
    

    useEffect(() => {
    }, [importedData, info])

    useEffect(() => {
    }, [fields, data]);


    const getEditableData = (data) => {
        return{
            InternalName: sanitizeValue(data?.InternalName),
            ExternalName: sanitizeValue(data?.ExternalName),
            SaleTypeDefault: sanitizeValue(data?.SaleTypeDefault),
            PaymentTypeDefaultSC: sanitizeValue(data?.PaymentTypeDefaultSC)
        }
    }

    const sanitizeValue = (value) => {
        if(isEmpty(value)) return null;
        return value;   
    }
    const isEmpty = (str) => {
        return (!str || str?.trim().length === 0);
    }

    const onSubmit = async (newData) => {
        setDeactivateBtn(true);
        let filtered = getEditableData(newData);
        const bres = await fiscForm?.current?.onBeforeSave(newData);
        ddd.values = filtered;
        ddd.filter = `Id="${data.Id}"`
        ddd.Modify().then(async res => {
            const ares = await fiscForm?.current?.onAfterSave(newData);
            onFiscResponse(bres, ares);
            setDeactivateBtn(false);
            _ddd.InvalidateSessionExtensions();
            NotificationManager.success(t("Device updated"), t("Success"), 4000);
            if(submitCallback)
                submitCallback(filtered, res)
        })
    }

    const onFiscResponse = (before, after) => {
        let error = "";
        if(before && before?.length > 0){
            before.forEach(b => error += b?.error?.data || b?.error?.message || b?.error?.Reason || t("Unknown error occured"));
        }
        if(after && after?.length > 0){
            after.forEach(b => error += b?.error?.data || b?.error?.message || b?.error?.Reason || t("Unknown error occured"));
        }
        if(error.length === 0) return;

        setError(error);
        setTimeout(() => {
            setError(null);
        }, 10000);
    }

    const onCancelConfirm = () =>{
        setConfirmDialog(false);
    }

    const onConfirmPackageChange = () =>{
        setConfirmDialog(false);
        handleSubmit(onSubmit)();
    }

    const onSaveClick = (e) =>{
        e.preventDefault();
        if(deactivateBtn) return;

        if(data["Activated"])
            return setConfirmDialog(true);

        handleSubmit(onSubmit)();
    }
    
    const onMoveToProd = (e) => {
        e.preventDefault();
        if(deactivateBtn) return;

        if(data?.Mode !== "TEST") return;

        let params = {
            DeviceId: data?.Id,
            Mode: "PROD"
        }
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.ChangeMode", params).then(res => {
            setDeactivateBtn(false);
            if(!res || res.result?.Status === "Error"){
                setError(res.result?.Reason || t("An unknown error occured. Please contact administrator."));
                setTimeout(() => {
                    setError(null);
                }, 10000);
            }else{
                setError(null);
                setData({...data, Mode:"PROD"});
                onDataChanged({...data, Mode:"PROD"});
                NotificationManager.success(t("Successfully moved to production"), t("Success"), 4000);
            }
        });
    }
    

    return (
        <>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmDialog}>
            <DialogTitle>{t("Confirm save override")}</DialogTitle>
            <DialogContent dividers>
            {t("This service is currently validated. Saving will deactivate this service and will have to be activated again.")}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onCancelConfirm}>
                {t("Cancel")}
                </Button>
                <Button onClick={onConfirmPackageChange}>{t("Ok")}</Button>
            </DialogActions>
        </Dialog>
        <Container fluid className={classes["formContainer"]}>
            <form onSubmit={onSaveClick} autocomplete="off">
                <h3 className={classes.subtitle}>General</h3>
                <div className={classes.FMContainer}>
                    <div className={classes.Fcontainer}>
                        <fieldset key={"InternalName"} className={classes["input-container"]}>
                            <label htmlFor={"InternalName"}>
                                Internal Name
                                <GenericTooltip tooltip={"Your internal name of this device"} fieldName={"InternalName"} placement="left"/>
                            </label>
                            {getFieldElement("InternalName")}
                        </fieldset>
                    </div>
                    <div className={classes.Fcontainer}>
                        <fieldset key={"ExternalName"} className={classes["input-container"]}>
                            <label htmlFor={"ExternalName"}>
                                External name
                                <GenericTooltip tooltip={"This is the name that will be used as display name on an invoice"} fieldName={"ExternalName"} placement="left"/>
                            </label>
                            {getFieldElement("ExternalName")}
                        </fieldset>
                    </div>
                    <div className={classes.Fcontainer}>
                        <fieldset key={"SaleTypeDefault"} className={classes["input-container"]}>
                            <label htmlFor={"SaleTypeDefault"}>
                                Sale type
                                {/* <GenericTooltip tooltip={""} fieldName={"InternalName"} placement="left"/> */}
                            </label>
                            {getFieldElement("SaleTypeDefault", "select")}
                        </fieldset>
                    </div>
                    <div className={classes.Fcontainer}>
                        <fieldset key={"PaymentTypeDefaultSC"} className={classes["input-container"]}>
                            <label htmlFor={"PaymentTypeDefaultSC"}>
                                Payment type
                                {/* <GenericTooltip tooltip={""} fieldName={"InternalName"} placement="left"/> */}
                            </label>
                            {getFieldElement("PaymentTypeDefaultSC", "select")}
                        </fieldset>
                    </div>
                </div>
                {sessionInfo?.Extended?.IsFiscalization && <>
                <h3 className={classes.subtitle}>Fiscalization</h3>
                <div className={classes.FMContainer}>
                    <div className={classes.Fcontainer} style={{width:"100%"}}>
                        <FiscalizationForm deviceId={data?.Id} ref={fiscForm} orgData={orgData}/>
                        {/* {sessionInfo?.Extended?.CountryCodeSC__CountryCode === "ME" && <>aaa</>} */}
                    </div>
                </div></>}
                {error && <div className="alert alert-danger mt-2 w-100">{error}</div>}
                <div className="text-end">
                    {data?.Mode === "TEST" && <Button className="ps-2 pe-2 me-4" onClick={onMoveToProd} disabled={deactivateBtn}>{t("Move to production")}</Button>}
                    <Button className="ps-2 pe-2" type="submit" disabled={deactivateBtn}>{t("Save")}</Button>
                </div>
            </form>
            </Container>
        </>
    )
}

export default DeviceForm;